import { useRegisterSW } from 'virtual:pwa-register/vue'

/**
 * Registra il service worker (strategia `prompt`) ed espone lo stato di
 * "nuova versione disponibile". Il reload avviene solo su `update()`.
 */
export function usePwaUpdate () {
  const { needRefresh, updateServiceWorker } = useRegisterSW({ immediate: true })
  return {
    needRefresh,
    update: () => updateServiceWorker(true)
  }
}
